module.exports = __webpack_public_path__ + "images/assets/9d23865480de4def4a926cc7c8b76751.svg";